import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";

import {
  MainLogo,
  Hambuger,
  MainLogoWhite,
  MobileContactLogo,
} from "../../../app-constants";
import DekstopHeader from "./dekstop-header";
import MobileHeader from "./mobile-header";

function Header({ bgcolor, lang, phone }) {
  const [isActive, setIsActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };
    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  const handleClick = (event) => {
    event.currentTarget.classList.toggle("active");
    document.body.classList.toggle("active");
    setIsActive((current) => !current);
  };
  let className = "tekrevol_header";
  if (bgcolor === "white") {
    className = "tekrevol_header white";
  }
  return (
    <div className={`${scrolled ? "active" : ""} ${className}`}>
      {/* <div className="new-main-head">
        <div className="ticker">
          <div className="marquee">
            {[...Array(8)].map((_, index) => (
              <a
                href="/business-plan-workshop"
                style={{ color: "#000" }}
                key={index}
              >
                <p>
                  Join our workshop: From Idea to Impact – Building Your
                  Business Blueprint, Tuesday, 03rd December 2024, 08:00 PM GST
                  | 10:00 AM CT –{" "}
                  <span style={{ color: "#f47a14" }}>Register Now!</span>
                </p>
              </a>
            ))}
          </div>
        </div>
      </div> */}
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={6} md={3} lg={2} xl={2} xxl={2} className="mt-auto mb-auto">
            <div className="tekrevol_logo">
              <Link to="/" aria-label="Go to home page">
                {bgcolor !== "white" || scrolled ? MainLogo : MainLogoWhite}
              </Link>
            </div>
          </Col>
          <Col
            xs={6}
            md={9}
            lg={10}
            xl={10}
            xxl={10}
            className="mt-auto mb-auto"
          >
            <ul className="mobile_header_icons">
              {phone !== undefined && phone !== "" ? (
                <li>
                  <Link to={`tel:${phone}`}>{MobileContactLogo}</Link>
                </li>
              ) : (
                <li>
                  <Link to="tel:+18003629239">{MobileContactLogo}</Link>
                </li>
              )}
              <li onClick={handleClick} className="navicon">
                {Hambuger}
              </li>
            </ul>

            {!isActive ? (
              <DekstopHeader lang={lang} />
            ) : (
              <MobileHeader lang={lang} />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Header;
